export default __webpack_public_path__ + "static/media/coupon-icon.9b83a21b.svg";